























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbSelect } from '@folky-tools/mdbvue';
import { Business } from '@/models/businesses/business';
import { Project } from '@/models/projects/project';
import { ProjectZone } from '@/models/projects/project-zone';
import { Pricing } from '@/models/pricings/pricing';
import { projectsService, pricingsService } from '@/services';
import { required } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect
    },
    validations: {
        business: {
            projects: { required },
            pricings: { required }
        }
    }
})
export default class BusinessProjectData extends Vue {
    @Prop(Business) private business!: Business;
    @Prop() private selectedProjectId!: number;
    @Prop() private singleColumnForm?: boolean;
    @Prop() private disableProjectsSelection?: boolean;
    private initialBusinesProjects: Project[] = [];
    private projects: Project[] = [];
    private projectZones: ProjectZone[] = [];
    private pricings: Pricing[] = [];

    private async mounted(): Promise<void> {
        this.initialBusinesProjects = this.business.projects.map(p => p.clone());

        let projects: Project[] = await projectsService.getProjects();
        if (this.selectedProjectId && this.business.projects.length) {
            projects.forEach(p => {
                if (p.id === this.selectedProjectId) {
                    p.selected = true;
                }
            });
        }
        if (projects && projects.length > 0 && this.selectedProjectId === 0) {
            projects.unshift(Project.Default(true));
            projects = projects.filter(p => !this.business.projects.some(bp => bp.id === p.id));
        }
        this.projects = projects;
    }

    private async onChangeProject(value: number, text: string): Promise<void> {
        if (value >= 0) {
            if (value === 0) {
                this.business.projects = this.initialBusinesProjects;
            } else {
                if (this.selectedProjectId === 0) {
                    this.business.projects = [...this.business.projects.filter(p => p.id !== this.selectedProjectId), this.projects.find(p => p.id === value)!];
                }
            }

            const projectZones: ProjectZone[] = await projectsService.getProjectZones(value);
            if (this.business.projects.some(p => p.id === value && p.zoneId)) {
                projectZones.forEach(pz => {
                    if (pz.id === this.business.projects.find(p => p.id === value)!.zoneId) {
                        pz.selected = true;
                    }
                });
            }
            if (projectZones && projectZones.length > 0) {
                projectZones.unshift(ProjectZone.Default(!projectZones.some(pz => pz.selected)));
            }
            this.projectZones = projectZones;

            const pricings: Pricing[] = await pricingsService.getPricings([value]);
            if (this.business.pricings.length) {
                const pricingtIds = this.business.pricings.map(p => p.id);
                pricings.forEach(p => {
                    if (pricingtIds.includes(p.id)) {
                        p.selected = true;
                    }
                });
            }
            this.pricings = pricings;
        } else {
            this.projectZones = [];
            this.pricings = [];
            this.business.pricings = [];
        }
    }

    private onChangePricing(value: number[], text: string) {
        if (value) {
            const selectedPricings: Pricing[] = [];
            this.pricings.forEach(p => {
                if (typeof value === 'number') {
                    if (value === p.id) {
                        selectedPricings.push(p);
                    }
                } else {
                    if (value.includes(p.id)) {
                        selectedPricings.push(p);
                    }
                }
            });
            this.business.pricings = [...this.business.pricings.filter(p => p.projectId !== this.selectedProjectId), ...selectedPricings];
        } else {
            this.business.pricings = [...this.business.pricings.filter(p => p.projectId !== this.selectedProjectId)];
        }
    }

    private onChangeProjectZone(value: number, text: string): void {
        const projectId = this.selectedProjectId > 0 ? this.selectedProjectId : this.projects.find(p => p.selected)!.id;
        if (value) {
            this.business.projects.find(p => p.id === projectId)!.zoneId = value;
            this.business.projects.find(p => p.id === projectId)!.zoneLocalizedName = this.projectZones.find(pz => pz.id === value)!.localizedName;
        } else {
            this.business.projects.find(p => p.id === projectId)!.zoneId = null;
            this.business.projects.find(p => p.id === projectId)!.zoneLocalizedName = null;
        }
    }

    private hasErrors(): boolean {
        this.$v.business.$touch();
        if (this.$v.business.$error) {
            return true;
        }
        return false;
    }
}
